import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import {
  SmartViewItemConfiguration,
  SmartViewsCreateRequest,
  SmartViewsRecentCreateRequest,
  SmartViewsUpdateRequest,
  StateGetResponse,
} from '../types';
import { ValidateViewNameResponse } from '@nirvana/shared/dtos/types/alerts/gz-console';

export class GenericGridSmartViewsBaseDataProvider extends BaseWebComponentDataProvider {
  public async getDataForView(): Promise<Array<SmartViewItemConfiguration>> {
    throw new Error('Not implemented');
  }

  public async addCustomView(
    componentName: string,
    details: SmartViewsCreateRequest
  ): Promise<SmartViewItemConfiguration> {
    throw new Error('Not implemented');
  }

  public async updateCustomView(
    componentName: string,
    updatedView: SmartViewsUpdateRequest
  ): Promise<SmartViewItemConfiguration> {
    throw new Error('Not implemented');
  }

  public async deleteCustomView(componentName: string, id: string): Promise<any> {
    throw new Error('Not implemented');
  }

  public async addRecentView(
    componentName: string,
    details: SmartViewsRecentCreateRequest
  ): Promise<SmartViewItemConfiguration> {
    throw new Error('Not implemented');
  }

  public async updateRecentView(
    componentName: string,
    id: string,
    details: SmartViewsUpdateRequest
  ): Promise<SmartViewItemConfiguration> {
    throw new Error('Not implemented');
  }

  public async addToFavorite(componentName: string, id: string): Promise<any> {
    throw new Error('Not implemented');
  }

  public async removeFromFavorite(componentName: string, id: string): Promise<any> {
    throw new Error('Not implemented');
  }

  public async readViews(componentName: string): Promise<Array<SmartViewItemConfiguration>> {
    throw new Error('Not implemented');
  }

  public async validateViewName(componentName: string, name: string): Promise<ValidateViewNameResponse> {
    throw new Error('Not implemented');
  }

  public async getSmartViewSettings(name: string): Promise<StateGetResponse> {
    throw new Error('Not implemented');
  }

  public async upsertState(records: Array<any>): Promise<Array<StateGetResponse>> {
    throw new Error('Not implemented');
  }
}
